import APIV5 from '~/models/api';
// eslint-disable-next-line import/no-cycle
import { WsManagerSingleton } from '~/services/websocket.service';
// eslint-disable-next-line import/no-cycle

/* globals Knitiv */

export class ResetModel {
	/* @ngInject */
	constructor(
		/** @type {Knitiv.RootScope} */
		$rootScope,
		/** @type {import('~/components/search-bar/search.factory').default} */
		Search,
	) {
		this.$rootScope = $rootScope;
		this.Search = Search;
	}

	resetApp(partial = false) {
		if (!partial) {
			localStorage.removeItem('cache');
			localStorage.removeItem('logo');
			localStorage.removeItem('token');
		}

		// Reset scope
		this.$rootScope.hasCreatePermissions = false;
		// @ts-ignore
		this.$rootScope.context = {};
		// @ts-ignore
		this.$rootScope.appConfig = undefined;
		this.$rootScope.tag = process.env.TAG;
		this.$rootScope.showHeader = false;
		this.$rootScope.showSearch = false;

		// Reset Search
		this.Search.clear();

		// Reset API
		APIV5.instance.setToken('');
		APIV5.instance.setBackEndpoint('');
		APIV5.instance.setFileEndpoint('');
		APIV5.instance.setFrontURL('');
		APIV5.instance.setFrontVersion('');

		const wsInstance = WsManagerSingleton.getInstance();

		wsInstance.setToken('');
		// @ts-ignore
		wsInstance.setURL('');
		wsInstance.destroy(1000, 'logout');
	}
}
